import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import Drip from 'drip';
import axios from '@/common/axios.config';
import qs from 'qs';
import { isProd } from '@/config/';
function YodaRequestCode(_x) {
  return _YodaRequestCode.apply(this, arguments);
}
function _YodaRequestCode() {
  _YodaRequestCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var projectId, uuid;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          projectId = _ref.projectId;
          _context2.next = 3;
          return Drip.getUuid();
        case 3:
          uuid = _context2.sent;
          return _context2.abrupt("return", new Promise(function (resolve) {
            axios.post('/tx/yoda/orderSlider/getRequestCode', qs.stringify({
              uuid: uuid,
              platform: 3,
              projectId: projectId
            }), {
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              }
            }).then(function (_ref7) {
              var code = _ref7.code,
                data = _ref7.data;
              resolve(code === 200 ? data : false);
            }).catch(function (res) {
              resolve(false);
            });
          }));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _YodaRequestCode.apply(this, arguments);
}
function YodaCheck(_ref2) {
  var requestCode = _ref2.requestCode,
    responseCode = _ref2.responseCode,
    projectId = _ref2.projectId;
  return new Promise(function (resolve) {
    axios.post("/tx/yoda/orderSlider/checkResponseCode", qs.stringify({
      requestCode: requestCode,
      responseCode: responseCode,
      projectId: projectId
    }), {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (_ref3) {
      var code = _ref3.code;
      resolve(code === 200);
    }).catch(function (res) {
      resolve(false);
    });
  });
}
var yodaCheckContext = null;
window.yodaSuccCb = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
    var requestCode, responseCode, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requestCode = _ref4.requestCode, responseCode = _ref4.responseCode;
          youdaRoot.className = '';
          youdaRoot.innerHTML = '';
          if (yodaCheckContext) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          if (!yodaCheckContext.jumpMaoyanCheckCode) {
            _context.next = 9;
            break;
          }
          yodaCheckContext.resultResolve(true);
          _context.next = 13;
          break;
        case 9:
          _context.next = 11;
          return YodaCheck({
            requestCode: requestCode,
            responseCode: responseCode,
            projectId: yodaCheckContext.projectId
          });
        case 11:
          result = _context.sent;
          yodaCheckContext.resultResolve(result);
        case 13:
          youdaRoot.className = '';
          youdaRoot.innerHTML = '';
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x2) {
    return _ref5.apply(this, arguments);
  };
}();
window.yodaFailCB = function (res) {
  youdaRoot.className = '';
  youdaRoot.innerHTML = '';
  if (!yodaCheckContext) return;
  yodaCheckContext.resultResolve(false);
};
var rootId = '_yoda_root_';
var youdaRoot = document.getElementById(rootId);
export default function EvokeYoda(_x3) {
  return _EvokeYoda.apply(this, arguments);
}
function _EvokeYoda() {
  _EvokeYoda = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var projectId, requestCode, resultResolve, resultReject, resultP, code, _options;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          projectId = _ref6.projectId, requestCode = _ref6.requestCode;
          if (!youdaRoot.innerHTML) {
            // 未使用
            yodaCheckContext = null;
          }
          // 已存在正在验证的yoda
          if (!yodaCheckContext) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return");
        case 4:
          resultP = new Promise(function (resolve) {
            resultResolve = resolve;
          });
          code = '';
          if (!requestCode) {
            _context3.next = 10;
            break;
          }
          code = requestCode;
          _context3.next = 13;
          break;
        case 10:
          _context3.next = 12;
          return YodaRequestCode({
            projectId: projectId
          });
        case 12:
          code = _context3.sent;
        case 13:
          if (code) {
            _context3.next = 16;
            break;
          }
          resultResolve(false);
          return _context3.abrupt("return", resultP);
        case 16:
          youdaRoot.className = 'show';
          youdaRoot.onclick = function (e) {
            if (e.target === youdaRoot) {
              // 关闭验证
              youdaRoot.className = '';
              youdaRoot.innerHTML = '';
              resultReject();
            }
          };
          yodaCheckContext = {
            projectId: projectId,
            resultResolve: resultResolve,
            jumpMaoyanCheckCode: !!requestCode
          };
          _options = {
            requestCode: code,
            //必须 授权码
            succCallbackFun: 'yodaSuccCb',
            //必须 成功回调函数名
            failCallbackFun: 'yodaFailCB',
            //必须 失败回调函数名
            root: rootId,
            //必须 挂载业务方页面节点id
            theme: "meituan",
            //必须 主题 默认‘meituan’
            isMobile: true,
            // 可选 true或1指定i版(H5)，false或0指定PC版。不指定则根据当前浏览器UA判断。
            style: {
              wrapper: '_yoda_wrapper'
            }
          }; // 环境 prod | ppe | staging | test | dev
          isProd ? YodaSeed(_options) : YodaSeed(_options, 'test');
          return _context3.abrupt("return", resultP);
        case 22:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _EvokeYoda.apply(this, arguments);
}